"use client";

import Link from "next/link";

type AccountNotFoundCopyProps = {
  email?: string;
  onSignUp?: () => void;
};

/**
 * Login copy when the email is unknown.
 * Sentence case + Oops + linked CTA — Slack/Airbnb phrasing, not ALL CAPS.
 */
export function AccountNotFoundCopy({ email, onSignUp }: AccountNotFoundCopyProps) {
  const href = email
    ? `/register?email=${encodeURIComponent(email)}`
    : "/register";

  return (
    <>
      Oops, we couldn&apos;t find an account with that email.{" "}
      {onSignUp ? (
        <button
          type="button"
          onClick={onSignUp}
          className="font-semibold underline underline-offset-2"
        >
          Sign up now
        </button>
      ) : (
        <Link href={href} className="font-semibold underline underline-offset-2">
          Sign up now
        </Link>
      )}{" "}
      to join.
    </>
  );
}
